// Treasury › Fees › Redeem — retired (SM-332).
//
// The redemption fee had its own page while it was a single global
// number. It is a fee_profiles field now, scoped like taker and maker,
// so it is configured on Fee policies alongside them and this route
// exists only to keep old links working.
//
// A redirect rather than a deletion: the standalone page was the answer
// to "where do I change the redeem fee" for weeks, and that URL is in
// bookmarks, runbooks and QA notes. Landing on Fee policies is the
// right answer to the question they were asking; a 404 is not.
//
// `replace` keeps the dead URL out of history, so Back from Fee
// policies goes where the operator actually came from instead of
// bouncing through the redirect again.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/treasury/fees/redeem")({
  beforeLoad: () => {
    throw redirect({ to: "/treasury/fees/policies", replace: true });
  },
});
